"use client"

import { ChevronLeft } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ChevronLeftIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ChevronLeftIcon = component(Icon)({ as: ChevronLeft })
